import request from '@/utils/request'

/**
 * 任务API
 *
 * @author Jay Qing
 * @since 2021/08/19
 */

/**
 * 基础接口
 *
 * @type {string}
 */
const BASE_URL = 'common/job'

export const JOB_BASE_URL = BASE_URL

/**
 * 分页查询接口
 *
 * @type {string}
 */
export const JOB_PAGE_URL = `${BASE_URL}/page`

/**
 * 查询指定ID的数据
 *
 * @param id ID
 * @returns {Promise}
 */
export function get(id: string) {
  return request({
    url: `${BASE_URL}/${id}`,
    method: 'get'
  })
}

/**
 * 保存数据
 *
 * @param data 数据
 * @returns {Promise}
 */
export function save(data: any) {
  return request({
    url: BASE_URL,
    method: 'post',
    data: data
  })
}

/**
 * 更新数据
 *
 * @param data 数据
 * @returns {Promise}
 */
export function update(data: any) {
  return request({
    url: BASE_URL,
    method: 'put',
    data: data
  })
}

/**
 * 更新状态
 *
 * @param data 新的状态
 * @return {Promise}
 */
export function updateStatus(data: any) {
  return request({
    url: `${BASE_URL}/status`,
    method: 'put',
    data: data
  })
}

/**
 * 删除数据
 *
 * @param idList ID数组
 * @returns {Promise}
 */
export function remove(idList: any) {
  return request({
    url: BASE_URL,
    method: 'delete',
    data: idList
  })
}

/**
 * 获取指定ID的任务状态
 *
 * @param id 任务ID
 */
export function state(id: any) {
  return request({
    url: `${BASE_URL}/state/${id}`,
    method: 'get'
  })
}

/**
 * 执行任务
 *
 * @param id 任务Id
 * @return {Promise}
 */
export function trigger(id: any) {
  return request({
    url: `${BASE_URL}/trigger/${id}`,
    method: 'put'
  })
}
